import React, { Component } from 'react';
import { ChartJsDataModel, MetricItem, SegmentItem } from '../../../domain/chart/ChartDomains';
import CustomPaginator, { CustomPaginatorProps } from '../../custom/CustomPaginator';

class TableChartComponent extends Component<Props, State> {
  public state = new State();

  render() {
    const { data } = this.props;
    const { paginatedData } = this.state;
    if (!data || !paginatedData) return null;
    if (!data.labels || !data.datasets || !paginatedData?.labels || !paginatedData?.datasets) return null;
    return (
      <div className={'flex flex-col w-full h-full overflow-x-auto overflow-y-auto'}>
        <table className={'w-full overflow-y-scroll'}>
          <thead>
            <tr className={'h-14 bg-main-gray  sticky top-0 text-left'}>{this.getTableHeaders()}</tr>
          </thead>
          <tbody>{this.getTableRows()}</tbody>
        </table>
        <div className={'flex w-full h-10 self-end justify-self-end'}>
          <CustomPaginator
            rows={this.state.rows}
            fixed={true}
            totalRecords={data.labels.length}
            rowsPerPageOptions={[5, 10, 50, 100]}
            onPageChange={this.onPageChange}
            currentPage={this.state.currentPage}
          />
        </div>
      </div>
    );
  }

  public componentDidMount() {
    this.paginateData();
  }

  private onPageChange = (props: CustomPaginatorProps) => {
    this.setState({ currentPage: props.page, rows: props.rows }, () => {
      this.paginateData();
    });
  };

  private paginateData = () => {
    const { data } = this.props;
    const { currentPage, rows } = this.state;
    const start = (currentPage - 1) * rows;
    const end = start + rows;
    const labels = data.labels.slice(start, end);
    const datasets = data.datasets.map((dataset) => {
      return {
        ...dataset,
        data: dataset.data.slice(start, end),
      };
    });
    this.setState({ paginatedData: { labels, datasets } });
  };

  private getTableRows = () => {
    const { paginatedData } = this.state;
    return paginatedData?.labels?.map((label: string, index: number) => {
      const datasetLabels = paginatedData.datasets.map((dataset) => dataset.label);
      return (
        <tr
          key={index}
          className={
            'h-[52px] min-h-[52px] border-b-[1px] border-t-[1px] border-[#E0E4E8] font-normal box-border even:bg-[#F9FAFB3D] overflow-x-scroll text-left '
          }
        >
          <th>
            <p className={'text-f-black-2 text-md font-normal opacity-100 px-3'}>{label}</p>
          </th>
          {datasetLabels?.map((datasetLabel, _index) => {
            const metric = this.props.metrics.find((m) => m.name == datasetLabel);
            return (
              <th key={_index + 'th'}>
                <p className={'text-f-black-2 text-md font-normal opacity-100 px-3'}>
                  {metric?.metric.appearance.prefix || ''}
                  {paginatedData.datasets.find((d) => d.label == datasetLabel)?.data[index]}
                  {metric?.metric.appearance.suffix || ''}
                </p>
              </th>
            );
          })}
        </tr>
      );
    });
  };

  private getTableHeaders = () => {
    const { segmentItem } = this.props;
    const { paginatedData } = this.state;
    const headers: string[] = [segmentItem?.name as string];
    paginatedData.datasets?.forEach((d) => headers.push(d.label));
    return headers.map((h, index) => {
      return (
        <th key={index} className={'overflow-x-scroll px-2 h-14  truncate'}>
          <p className={'text-md text-f-black-2 font-medium flex w-full items-center justify-start h-full'}>{String(h)}</p>
        </th>
      );
    });
  };
}

interface Props {
  data: ChartJsDataModel;
  segmentItem?: SegmentItem;
  metrics: MetricItem[];
}

class State {
  currentPage: number = 1;
  rows: number = 10;
  paginatedData: ChartJsDataModel = {
    labels: [],
    datasets: [],
  };
}

export default TableChartComponent;
